<div class="support__banner">
  <h2 class="support__title">Need more help?</h2>
  <div class="support__content">
    <p class="support__description">If you didn't find what you looking for, please raise a support ticket.</p>
    <button class="support__button" (click)="openSupportTicketModal()">
      Raise a support ticket
    </button>
  </div>
</div>
